import { StateCreator } from "zustand";

export interface LoadingSlice {
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
}

const createLoadingSlice: StateCreator<LoadingSlice, [], [], LoadingSlice> = (
  set,
) => ({
  isLoading: false,
  setIsLoading: (loading: boolean) => {
    set({ isLoading: loading });
  },
});

export default createLoadingSlice;
